export default "__VITE_ASSET__BDHk57rG__"